import React from "react";
import { CustomerController } from "./CustomerController";
import { CustomerViewModel } from "./CustomerViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class CustomerProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new CustomerViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <CustomerController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerProvider.js